<template>
	<el-form :model="form" label-width="105px" class="form">
		<div class="subTit"><i class="el-icon-caret-bottom" />基本信息</div>
		<div class="center">
			<el-form-item label="展会名称:">
				<el-input v-model="form.title" />
			</el-form-item>
			<el-form-item label="展会封面图" prop="photo">
				<!-- element-loading-background="rgba(250, 250, 250, 0.3)"
					:show-file-list="false"  -->
				<el-upload class="avatar-uploader" :action="picUrl" :show-file-list="false"
					element-loading-text="拼命加载中……" :on-progress="change" :before-upload="beforeAvatarUpload"
					v-loading.fullscreen.lock="loading" :data="fileInfo" :on-success="handleAvatarSuccess"
					accept="image/jpeg,image/png">
					<!-- :onerror="imgSrc"  -->
					<img v-if="imageUrl" :src="imageUrl" :onerror="imgSrc" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<div class="tishinews">
					<!-- 小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					<br />图片建议比例:3:2 -->
				</div>
			</el-form-item>
			<!-- 	<el-form-item label="分区:" >
				<template  v-for="(item,index) in list" :key="item">
					<div class="">
						<el-input type="text" :v-model="item" :value="list[index]"   @input="changefenqu($event)"  class="fenqu" />
					</div>
				</template>
			
			</el-form-item> -->
			<el-form-item label="分区:">
				<div class="nav-td" v-for="(items,indexs) in list" :key="items.name">
					<div class="nav-td-item">
						<input type="text" class="child-text fenqu" v-model="items.name">
					</div>
				</div>
				<div class="attr-add-btn" @click="handleAddAttr"><i class="el-icon-plus" />添加分区</div>
			</el-form-item>
		</div>
		<div class="submit-btn" @click="handleSubmit">保存</div>
	</el-form>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					title: '',
					photo: '',
					fenqu: []
				},
				fileInfo: {
					type: "Goods",
				},
				picUrl: '',
				imageUrl: '',
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				list: [],
				exhibition_id:'',
				iszhs:''
			}
		},
		created(optiond) {
			this.picUrl = this.$store.state.BASE_URL + '/uploadImgOne.html'
			if(this.$route.query.id > 0){
				this.exhibition_id = this.$route.query.id
				this.getdata()
			}
			
		},
		methods: {
			getdata(){
				this.$axios.post('Exhibition-Admin-getExhibitionShopInfo', {exhibition_id:this.exhibition_id}).then(data => {
					this.form.title  =data.title
					this.form.photo  =data.photo
					this.imageUrl =data.photo ? this.$store.state.IMG_URL+data.photo :''
					this.form.fenqu  =data.fenqu
					let a = []
					data.fenqu.map((item)=>{
						a.push({
							name:item
						})
					})
					this.list = a
					
				})
			},
			changefenqu() {
				this.$forceUpdate()
			},
			change(event, file, fileList) {
				this.loading = true;
			},
			// 添加分区
			handleAddAttr() {
				this.list.push({
					name:'',
				})
			},
			handleAvatarSuccess(res, file) {
				if (res.src != null) {
					this.loading = false;
					this.form.photo = res.src
					this.imageUrl = URL.createObjectURL(file.raw);
				} else {
					this.loading = false;
					this.$message.error(res.data);
				}
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			handleSubmit() {
				let b = []
				this.list.map((i,ind)=>{
					b.push(i.name)
				})
				this.form.fenqu = b
				this.form.user_id = this.$store.state.SELLER_ID
				this.$emit("eventForm",this.form)
			}
		},
		components: {}
	}
</script>

<style scoped>
	.fenqu {
		display: block;
		margin: 10px 0;
		width: 200px !important;
		-webkit-appearance: none;
		background-color: #fff;
		background-image: none;
		-webkit-border-radius: 4px;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 40px;
		line-height: 40px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		-o-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
	}

	.form>>>.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
